// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

export const PayerOption = {
    CLAIMS_CHK: 'CLAIMS_CHK',
    CLAIMSLOOK: 'CLAIMSLOOK',
    NO_MKT_MED: 'NO_MKT_MED',
    NO_MKT_PH: 'NO_MKT_PH',
    PRESC_FAX: 'PRESC_FAX',
    USE_CBI: 'USE_CBI',
    COPAY_MESSAGE_TITLE: 'CPY_MSG_TT',
    COPAY_MESSAGE_SHORT: 'CPY_MSG_S',
    COPAY_MESSAGE_LONG: 'CPY_MSG_L',
};

// Drop Down Options
export const ContractTypeOptions = [
    { name: 'Home Infusion Therapy (HIT)', value: 'HIT' },
    { name: 'Medical Specialty Pharmacy (MSP)', value: 'MSP' },
];

export const ORG_SIZE_OPTIONS = ['Large', 'Medium', 'Small'];
export const SWITCH_PROVIDER_OPTIONS = ['Change Healthcare', 'Relay Health'];
export const PHARMACY_TYPE_OPTIONS = [
    'Commercial',
    'Mid-Market',
    'HSSP',
    'MID',
    'Home Infusion Therapy',
];
export const PSAO_OPTIONS = [
    'None',
    'Accelerate',
    'Elevate',
    'CPS',
    'Premier',
    'Shields',
    'Innovatix',
];
export const ACCREDITATION_OPTIONS = ['URAC', 'ACHC', 'NABP', 'JCAHO', 'NCODA'];

// User Management
export const UserType = {
    PRESCRIBER: 'prescriber',
    SUPPLIER: 'supplier',
    PAYER: 'payer',
    COMPASS: 'compass',
    LIGHTHOUSE: 'lighthouse',
};

/** Route param used for create pages */
export const CREATE_ROUTE = 'create';

/** All SKUs with an id equal or less to this value are considered Standard SKUs and can't be edited */
export const MAX_STANDARD_SKU_ID = 5;

/** Global backstop segment_id */
export const GLOBAL_SEGMENT_ID = 'global';
